import type React from "react";

interface InfoIconProps {
  className?: string;
}

export const InfoIcon: React.FC<InfoIconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <circle cx="9" cy="9" r="7.5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M9 8V12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="9" cy="5.5" r="1" fill="currentColor" />
  </svg>
);
